<template>
  <div class="post-bar" @click="postBarEntry"
    :style="{
      bottom: bottomDistance
    }"
  >
    <svg-icon name="icon-bold-add" :style="{color: isOppo ? '#000' : '#FFF'}" />
  </div>
  <WapDialog v-model:show="showPop" :showCancel="true" :showConfirm="false" :round="true" :bottom="true" buttonColor="var(--color-text-secondary)">
    <div class="post-menu" :class="[isOneplusOversea && 'oneplusbar']">
      <div 
        v-for="item in postList" 
        :key="item"
        @click="toPost(item)"
      >
        <svg-icon :name="`icon-${item}`"/>
        <span>{{ $t(item) }}</span>
      </div>
    </div>
  </WapDialog>
  
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user'
import { useSystemStore } from '@/stores/system'
const userStore = useUserStore()
const systemStore = useSystemStore()
const { uid } = storeToRefs(userStore)
const { isApp, isOneplus, isOppoApp, versionCode, isOppo } = storeToRefs(systemStore)
const { proxy } = getCurrentInstance()

const props = defineProps({
  circleId: {
    type: String,
    default: ''
  },
  topicId: {
    type: String,
    default: ''
  },
  topicName: {
    type: String,
    default: ''
  }
})
const route = useRoute()
const router = useRouter()
const showPop = ref(false)

const isOneplusOversea = import.meta.env.VITE_COUNTRY === 'PARIS'

const bottomDistance = computed(() => {
  return localStorage.hiddenAppDialog ? '40px' : '88px'
})

const postList = computed(() => {
  // return isOneplusOversea ? ['moment', 'article', 'poll', 'feedBack'] : ['moment', 'article', 'poll']
  return ['moment', 'article', 'poll']
})

const postBarEntry = () => {
  showPop.value = true
  proxy.$ga('FAB_entry', {
    "screen_name": route.name
  })
}

const toPost = (type) => {
  let categoryType
  switch (type) {
    case 'moment':
      categoryType = 2;
      break;
    case 'article':
      categoryType = 1;
      break;
    case 'poll':
      categoryType = 4;
      break;
    default:
      categoryType = 3;
  }
  proxy.$ga('FAB_Selection', {
    "screen_name": route.name,
    "thread_category": categoryType
  })
  if (type === 'feedBack') {
    const link = `${location.origin}/feedback`
    if (isApp.value) {
      proxy.$openNewWebview(link)
    } else {
      window.open(link)
    }
    return
  }
  if (!uid.value) {
    showPop.value = false
    userStore.onShowLoginPopup()
    return
  }
  // 社区app跳原生发帖页
  if ((isOneplus.value || isOppoApp.value) && versionCode.value >= 42800) {
    const data = {
      threadType: categoryType
    }
    if (props.circleId) {
      data.circleId = props.circleId
    }
    if (props.topicId) {
      data.topicInfo = JSON.stringify([{id: props.topicId, name: props.topicName}])
    }
    proxy.$openPostPage(data)
    return
  }
  let routeDetail = {
    name: 'post',
    params: {
      type
    }
  }
  if (props.circleId) {
    routeDetail.query = {
      circleId: props.circleId
    }
  }
  if (props.topicId) {
    routeDetail.query = {
      topicId: props.topicId,
      topicName: props.topicName
    }
  }
 
  router.push(routeDetail)
}

watch(() => route.name, (val) => {
  setTimeout(() => {
    showPop.value = false
  }, 100);
})
defineExpose({
  showPop
})

</script>

<style lang="postcss" scoped>
  .post-bar {
    position: fixed;
    bottom: 40px;
    right: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 100px;
    background: var(--color-brand-default);
    z-index: 90;
    .svg-icon {
      width: 26px;
      height: 26px;
      /* transform: rotate(45deg); */
    }
  }
 
  .post-menu {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 10px 12px;
    div {
      flex: 1;
      display: flex;
      flex-flow: column wrap;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      padding: 18px 4px 8px;
      text-align: center;
    }
    .svg-icon {
      width: 32px;
      height: 32px;
      margin-bottom: 8px;
      color: var(--theme);
      transform: unset;
    }
  }
</style>